export const soundOptions = [
  { label: 'dashboard_none', value: 'none' },
  { label: 'notifications_view_sound_default', value: 'default' },
  { label: 'notifications_view_sound_pop', value: 'pop' },
  { label: 'notifications_view_sound_tone', value: 'tone' },
  { label: 'notifications_view_sound_achievement', value: 'achievement' },
  { label: 'notifications_view_sound_chord', value: 'chord' },
  { label: 'notifications_view_sound_clearly', value: 'clearly' },
  { label: 'notifications_view_sound_didit', value: 'didit' },
  { label: 'notifications_view_sound_done', value: 'done' },
  { label: 'notifications_view_sound_elegant', value: 'elegant' },
  { label: 'notifications_view_sound_hollow', value: 'hollow' },
  { label: 'notifications_view_sound_light', value: 'light' },
  { label: 'notifications_view_sound_maybe', value: 'maybe' },
  { label: 'notifications_view_sound_press', value: 'press' },
  { label: 'notifications_view_sound_retro', value: 'retro' },
  { label: 'notifications_view_sound_reveal', value: 'reveal' },
  { label: 'notifications_view_sound_sharp', value: 'sharp' },
  { label: 'notifications_view_sound_swiftly', value: 'swiftly' },
  { label: 'notifications_view_sound_together', value: 'together' },
  { label: 'notifications_view_sound_whatif', value: 'whatif' },
  { label: 'notifications_view_sound_when', value: 'when' }
]

export const durationOptions = [
  { label: '2', value: 2000 },
  { label: '4', value: 4000 },
  { label: '6', value: 6000 },
  { label: '8', value: 8000 },
  { label: '10', value: 10000 }
]

export const emailIntervalOptions = [
  { label: '10', value: 6e5 },
  { label: '12', value: 7.2e5 },
  { label: '14', value: 8.4e5 },
  { label: '16', value: 9.6e5 },
  { label: '18', value: 1.08e6 },
  { label: '20', value: 1.2e6 }
]
